import MembershipsMasterView from './MembershipsMasterView';

export default MembershipsMasterView;
